
export const RequiredIndicator = () => (
  <span className="text-[#ea384c] ml-1">*</span>
);

export default RequiredIndicator;
